import StyledButton from '@components/Button';
import styled from '@emotion/styled';
import { SHOW_HEADER } from '@utils/globals';
import RES from '@utils/resources';
import ROUTES from '@utils/routes';
import STRINGS from '@utils/strings';
import { useNavigate } from 'react-router';

const InfoContainer = styled.div(({ theme }) => ({
    minHeight: SHOW_HEADER ? `calc(100vh - ${theme.size.headerHeight})` : '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundImage: `linear-gradient(rgba(232, 232, 232, 0.9), rgba(232, 232, 232, 0.9)), url(${RES.images.campaignImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.mediaQuery.desktopUp]: {
        backgroundSize: '1200px auto'
    }
}));

const Label = styled.h1(({ theme }) => ({
    ...theme.typography.h1,
    margin: `${theme.spacing.xl} 0 ${theme.spacing.m} 0`,
    textAlign: 'center',
    color: theme.colors.tertiaryLight
}));

function NotFound() {
    const history = useNavigate();

    return (
        <InfoContainer>
            <Label>{STRINGS.notFound}</Label>
            <StyledButton
                onClick={() => {
                    history.push(ROUTES.home);
                }}
            >
                {STRINGS.goToHome}
            </StyledButton>
        </InfoContainer>
    );
}

export default NotFound;
